import script from "./ModalSubirListaGestionMas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalSubirListaGestionMas.vue?vue&type=script&setup=true&lang=ts"

import "./ModalSubirListaGestionMas.vue?vue&type=style&index=0&id=10ac4a13&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ac4a13"]])

export default __exports__